import { DATA_LAYER_COBASI, isDataLayerCobasiEnabled } from "./constants";
import { buildCurrentPageData, getAnalyticsUserData } from "./helpers";

import type { UserData } from "./types";

type DataLayerWindow = Window & {
  dataLayer?: Record<string, unknown>[];
  dataLayerCobasi?: Record<string, unknown>[];
};

export const getDataLayer = (): Record<string, unknown>[] => {
  const dataLayerWindow = window as DataLayerWindow;
  dataLayerWindow[DATA_LAYER_COBASI] = dataLayerWindow[DATA_LAYER_COBASI] || [];
  return dataLayerWindow[DATA_LAYER_COBASI];
};

export const pushDataLayerCobasi = (
  ...payloads: Record<string, unknown>[]
): void => {
  if (typeof window === "undefined") return;
  if (!isDataLayerCobasiEnabled()) return;

  const dataLayer = getDataLayer();
  payloads.forEach((payload) => dataLayer.push(payload));
};

export const pushEcommerceGa4DataLayer = ({
  eventName,
  ecommerce,
  userData
}: {
  eventName: string;
  ecommerce: Record<string, unknown>;
  userData?: UserData & Record<string, unknown>;
}): void => {
  pushDataLayerCobasi(
    { ecommerce: null, page_data: null },
    {
      event: "ecommerce_ga4",
      event_name: eventName,
      ecommerce,
      page_data: buildCurrentPageData(),
      user_data: userData || getAnalyticsUserData()
    }
  );
};
